import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
var BrowserFileSystem = function () {
  function BrowserFileSystem(files) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, BrowserFileSystem);
    this._fetch = options.fetch || fetch;
    this.files = {};
    for (var i = 0; i < files.length; ++i) {
      var file = files[i];
      this.files[file.name] = file;
    }
    this.fetch = this.fetch.bind(this);
  }
  _createClass(BrowserFileSystem, [{
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(path) {
        var options,
          fallbackFetch,
          file,
          response,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                if (!path.includes('://')) {
                  _context.next = 4;
                  break;
                }
                fallbackFetch = options.fetch || this._fetch;
                return _context.abrupt("return", fallbackFetch(path, options));
              case 4:
                file = this.files[path];
                if (!file) {
                  _context.next = 9;
                  break;
                }
                response = new Response(this.files[path]);
                Object.defineProperty(response, 'url', {
                  value: path
                });
                return _context.abrupt("return", response);
              case 9:
                return _context.abrupt("return", new Response(path, {
                  status: 400,
                  statusText: 'NOT FOUND'
                }));
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function fetch(_x) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "readdir",
    value: function () {
      var _readdir = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
        var files, path;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                files = [];
                for (path in this.files) {
                  files.push(path);
                }
                return _context2.abrupt("return", files);
              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function readdir() {
        return _readdir.apply(this, arguments);
      }
      return readdir;
    }()
  }, {
    key: "stat",
    value: function () {
      var _stat = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(path, options) {
        var file;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                file = this.files[path];
                if (file) {
                  _context3.next = 3;
                  break;
                }
                throw new Error("No such file: ".concat(path));
              case 3:
                return _context3.abrupt("return", {
                  size: file.size
                });
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function stat(_x2, _x3) {
        return _stat.apply(this, arguments);
      }
      return stat;
    }()
  }, {
    key: "unlink",
    value: function () {
      var _unlink = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4(pathname) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                delete this.files[pathname];
              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function unlink(_x4) {
        return _unlink.apply(this, arguments);
      }
      return unlink;
    }()
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator(_regeneratorRuntime.mark(function _callee5(pathname) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.files[pathname]);
              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function open(_x5) {
        return _open.apply(this, arguments);
      }
      return open;
    }()
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator(_regeneratorRuntime.mark(function _callee6(fd, _ref) {
        var _ref$buffer, buffer, _ref$offset, offset, _ref$length, length, _ref$position, position, file, arrayBuffer;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref$buffer = _ref.buffer, buffer = _ref$buffer === void 0 ? null : _ref$buffer, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 0 : _ref$offset, _ref$length = _ref.length, length = _ref$length === void 0 ? buffer.byteLength : _ref$length, _ref$position = _ref.position, position = _ref$position === void 0 ? null : _ref$position;
                file = fd;
                _context6.next = 4;
                return readFileSlice(file, position, position + length);
              case 4:
                arrayBuffer = _context6.sent;
                return _context6.abrupt("return", arrayBuffer);
              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      function read(_x6, _x7) {
        return _read.apply(this, arguments);
      }
      return read;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator(_regeneratorRuntime.mark(function _callee7(fd) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      function close(_x8) {
        return _close.apply(this, arguments);
      }
      return close;
    }()
  }]);
  return BrowserFileSystem;
}();
export { BrowserFileSystem as default };
function readFileSlice(_x9, _x10, _x11) {
  return _readFileSlice.apply(this, arguments);
}
function _readFileSlice() {
  _readFileSlice = _asyncToGenerator(_regeneratorRuntime.mark(function _callee8(file, start, end) {
    var slice;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            slice = file.slice(start, end);
            _context8.next = 3;
            return new Promise(function (resolve, reject) {
              var fileReader = new FileReader();
              fileReader.onload = function (event) {
                return resolve(event.target && event.target.result);
              };
              fileReader.onerror = function (error) {
                return reject(error);
              };
              fileReader.readAsArrayBuffer(slice);
            });
          case 3:
            return _context8.abrupt("return", _context8.sent);
          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _readFileSlice.apply(this, arguments);
}
//# sourceMappingURL=browser-filesystem.js.map